<crowdctrl-unauthenticated-page [pageTitle]="pageTitle" [showFooter]="false" defaultHref="/about">
  <div class="about-future-directions">
    <p class="about-future-directions__lede">
      We take CrowdCTRL's long-term direction seriously. This section explains the problems and
      outcomes we care about next; it is updated as our plans mature and as we can speak to them
      concretely.
    </p>

    <section class="about-future-directions__section" aria-labelledby="fd-sdg-heading">
      <h2 id="fd-sdg-heading" class="about-future-directions__heading">
        Sustainable development goals
      </h2>
      <p class="about-project__text">
        CrowdCTRL is built around fair access and transparent, policy-driven decisions when demand
        spikes and informal signalling breaks down. We treat equity and accountability as
        engineering problems, not slogans: queues and policies should be understandable,
        contestable, and hard to game. The two goals below are the ones we most often map our work
        to; CrowdCTRL's job is to make queue rules and their trade-offs visible in real operations.
      </p>

      <div
        class="dashboard-tiles about-future-directions__sdg-tiles"
        role="list"
        aria-labelledby="fd-sdg-heading"
      >
        <article class="service-tile about-future-directions__sdg-tile" role="listitem">
          <img
            class="about-future-directions__sdg-icon"
            src="/images/sdg-goal-10.png"
            width="96"
            height="96"
            alt="Sustainable Development Goal 10: Reduced inequalities"
          />
          <h3 class="about-future-directions__sdg-title">Reduced inequalities</h3>
          <p class="about-future-directions__sdg-official">
            Sustainable Development Goal 10: reduce inequality within and among countries.
          </p>
          <p class="about-future-directions__sdg-body">
            Fair queues and clear rules reduce arbitrary advantage when demand exceeds capacity:
            people can see why a policy applies and what it changes for them, instead of relying on
            who shouts loudest.
          </p>
        </article>

        <article class="service-tile about-future-directions__sdg-tile" role="listitem">
          <img
            class="about-future-directions__sdg-icon"
            src="/images/sdg-goal-16.png"
            width="96"
            height="96"
            alt="Sustainable Development Goal 16: Peace, justice and strong institutions"
          />
          <h3 class="about-future-directions__sdg-title">Peace, justice and strong institutions</h3>
          <p class="about-future-directions__sdg-official">
            Sustainable Development Goal 16: promote peaceful and inclusive societies, provide
            access to justice for all, and build effective, accountable institutions at all levels.
          </p>
          <p class="about-future-directions__sdg-body">
            Policy-driven operations need traceable decisions and institutions staff can stand
            behind: not opaque overrides, but rules teams can explain, audit, and improve.
          </p>
        </article>
      </div>

      <p class="about-future-directions__sdg-attribution">
        Goal icons and names follow the
        <a
          href="https://www.un.org/sustainabledevelopment"
          target="_blank"
          rel="noopener noreferrer"
          class="about-project__inline-link"
        >
          UN Sustainable Development Goals
        </a>
        framework.
      </p>
    </section>

    <section class="about-future-directions__section" aria-labelledby="fd-explore-heading">
      <h2 id="fd-explore-heading" class="about-future-directions__heading">
        What we are exploring
      </h2>
      <p class="about-project__text">
        Right now we are building transparent, policy-driven queues and the surfaces staff use when
        demand spikes.
        <a
          href="/about"
          class="about-project__inline-link"
          (click)="unauthNav.forward($event, '/about')"
          >About</a
        >,
        <a
          href="/about/features"
          class="about-project__inline-link"
          (click)="unauthNav.forward($event, '/about/features')"
          >Features</a
        >, and
        <a
          href="/about/how-it-works"
          class="about-project__inline-link"
          (click)="unauthNav.forward($event, '/about/how-it-works')"
          >How it works</a
        >
        describe what is in the product today.
      </p>
      <p class="about-project__text">
        Next we are pushing on policies that are easier to read and harder to misuse, and on clearer
        views of who gets served and what happens next for teams that want that visibility.
      </p>
    </section>

    <a href="/about" class="about-project__back-link" (click)="unauthNav.forward($event, '/about')"
      >Back to About</a
    >
  </div>
</crowdctrl-unauthenticated-page>
